const MODAL_TYPE = {
  DESCRIBE: "describe",
  PROJECT_COMPLETE: "project-complete",
  CONFIRM: "confirm",
  CONFIRM_SCREENING_FORM: "confirm-screening-form",
};

export { MODAL_TYPE };
